import { store } from '../../store';
import { addMessage, updateConversationInHistory } from '../../store/chat/slice';
import { ConversationStatus } from '../../store/chat/types';
import { SocketMessage } from '../types';
import { createErrorMessage } from '../../store/chat/slice';
import { sendConversationStatus } from '../publishers/sendConversationStatus';

export interface ChatErrorPayload {
  message: string;
  conversationId: string;
  code?: string;
}

export async function chatErrorHandler(message: SocketMessage<ChatErrorPayload>): Promise<void> {
  const payload = message.payload as ChatErrorPayload;
  const conversationId = payload.conversationId;

  if (!payload || !conversationId) return;

  const state = store.getState();
  const currentConversation = state.chat.conversation;

  // if it's the current conversation, mark seen and add error message
  const isCurrentConversation = currentConversation && currentConversation.id === conversationId;
  const newStatus = isCurrentConversation ? ConversationStatus.Inactive : ConversationStatus.Error;
  if (isCurrentConversation) {
    await sendConversationStatus(conversationId, newStatus);

    // append error message to the conversation
    const errorMessage = createErrorMessage(
      'Sorry, there was an error processing your request. Please try again.',
    );
    store.dispatch(addMessage(errorMessage));
  }

  store.dispatch(
    updateConversationInHistory({ id: conversationId, updates: { status: newStatus } }),
  );
}
